<template>
  <b-row>
    <b-col>
      <b-card class="styled-card">
        <div class="d-flex justify-content-center flex-column" style="line-height: 19px;">
          <p v-if="serviceCall.client_id" class="mb-0 font-weight-bold fs-18" style="color: #333">
            <span>{{ serviceCall.client.client_num }}</span>
            <sup v-if="serviceCall.client.sap_frozen || !serviceCall.client.sap_valid" class="opt-invalid">
              Inactivo
            </sup>
          </p>

          <p class="mb-0 text-muted fs-20">
            <span v-if="serviceCall.client_id">{{ serviceCall.client.name }}</span>
            <span v-else class="text-uppercase">{{ serviceCall.client_name }}</span>
          </p>
        </div>
        <hr>
        <b-row class="text-center">
          <b-col cols="6" lg="3">
            <div class="d-flex flex-column" style="line-height: 18px;">
              <span>Categoría del servicio</span>
              <span v-if="serviceCall.sap_series" class="fs-15 text-muted text-uppercase">{{ sapSeriesMap[serviceCall.sap_series] }}</span>
              <span v-else class="fs-15 text-danger">No definido</span>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <div class="d-flex flex-column" style="line-height: 18px;">
              <span>Unidad de negocio</span>
              <span v-if="serviceCall.call_type == 'unidad_pendiente'" class="fs-15 text-muted text-uppercase">Pendiente</span>
              <span v-else-if="serviceCall.call_type" class="fs-15 text-muted text-uppercase">{{ callTypeMap[serviceCall.call_type] }}</span>
              <span v-else class="fs-15 text-muted text-uppercase">No definida</span>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <div class="d-flex flex-column" style="line-height: 18px;">
              <span>Fecha de compromiso</span>
              <span v-if="serviceCall.due_on" class="fs-15 text-muted text-uppercase">{{ serviceCall.due_on | formatDate }}</span>
              <span v-else class="fs-15 text-danger">No definida</span>
            </div>
          </b-col>
          <b-col cols="6" lg="3">
            <div class="d-flex flex-column" style="line-height: 18px;">
              <span>Tipo de equipo</span>
              <span v-if="serviceCall.system_type" class="fs-15 text-muted text-uppercase">{{ serviceCall.system_type }}</span>
              <span v-else class="fs-15 text-danger">No definida</span>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { callTypeMap } from '../../../../sharedOptions/serviceCallModule'

export default {
  name: 'SubheaderCard',
  props: {
    serviceCall: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sapSeriesMap: {
        285: 'OS INST',
        248: 'OS OAS',
        222: 'OS LABS',
        235: 'OS CM',
        61: 'OS SERVICIO',
        206: 'OS EMERGENCIA',
        261: 'OS ATK'
      },
      callTypeMap : callTypeMap
    }
  },
}
</script>

<style scoped>
  .styled-card {
    border-radius: 8px;
    border: 2px solid #e2e8f0;
  }
  .opt-invalid {
    font-size: 0.7rem;
    font-weight: 700;
    background: #d84b2e;
    color: #ffffff;
    padding: 2px 7px;
    border-radius: 4px;
    margin-left: 0.25rem;
  }
</style>
